import "./Careers.module.css";
import Navigation from "@/reusable_sections/Header";
import Join from "./sections/Join";
import Application from "./sections/Application";
import Benefits from "./sections/Benefits";
import Footer from "@/reusable_sections/Footer";
export default function CareersPage() {
  return <div>
      <Navigation />
      <Join />
      <Application />
      <Benefits />
      <Footer />
    </div>;
}